module.exports = __webpack_public_path__ + "img/Menu_unidade_Activo.5ee1b268.svg";